import React from 'react';

const CreditCard = ({type, cardNumber, expirationDate}) => {
  return(
    <svg height="auto" viewBox="0 0 780 500" width="100%" xmlns="http://www.w3.org/2000/svg">
      <rect fill="#393939" height="500" rx="40" width="780" />
      <g fill="#fff">
        <rect fill="#a5a35b" fillOpacity=".75" height="99.679" rx="20.323" width="110.32" x="48.71" y="153.58" />
        <text x="78" y="345" fill="white" fillOpacity=".784" style={{fontSize:"50pt"}}>
          {cardNumber}
        </text>
        <text x="78" y="410" fill="white" fillOpacity=".784" style={{ fontSize: "35pt" }}>
          {type}
        </text>
        <text x="300" y="410" fill="white" fillOpacity=".784" style={{ fontSize: "40pt" }}>
          {expirationDate}
        </text>
      </g>
    </svg>
  )
}

export default CreditCard;